export default __webpack_public_path__ + "static/media/20220721-093039-new.b8e04c52.png";